// Import project images - organized by project subfolders

// eRestaurant POS System
import Res1 from "../../assets/img/project/erestaurant/Res1.png";
import Res2 from "../../assets/img/project/erestaurant/Res2.png";
import Res3 from "../../assets/img/project/erestaurant/Res3.png";
import Res4 from "../../assets/img/project/erestaurant/Res4.png";
import Res5 from "../../assets/img/project/erestaurant/Res5.png";

// eStock Inventory Management
import Stock1 from "../../assets/img/project/estock/Stock1.png";
import Stock2 from "../../assets/img/project/estock/Stock2.png";
import Stock3 from "../../assets/img/project/estock/Stock3.png";
import Stock4 from "../../assets/img/project/estock/Stock4.png";
import Stock5 from "../../assets/img/project/estock/Stock5.png";

// Customer Relationship Manager
import CRM1 from "../../assets/img/project/crm/CRM1.png";
import CRM2 from "../../assets/img/project/crm/CRM2.png";
import CRM3 from "../../assets/img/project/crm/CRM3.png";

// StockTally Mobile App
import stocktally1 from "../../assets/img/project/stocktally/StockTally1.png";
import stocktally2 from "../../assets/img/project/stocktally/StockTally2.png";
import stocktally3 from "../../assets/img/project/stocktally/StockTally3.png";
import stocktally4 from "../../assets/img/project/stocktally/StockTally4.png";
import stocktally5 from "../../assets/img/project/stocktally/StockTally5.png";
import stocktally6 from "../../assets/img/project/stocktally/StockTally6.png";
import stocktally7 from "../../assets/img/project/stocktally/StockTally7.png";
import stocktally8 from "../../assets/img/project/stocktally/StockTally8.png";

// Asset Management System
import Asset1 from "../../assets/img/project/asset-management/Asset1.png";
import Asset2 from "../../assets/img/project/asset-management/Asset2.png";
import Asset3 from "../../assets/img/project/asset-management/Asset3.png";
import Asset4 from "../../assets/img/project/asset-management/Asset4.png";
import Asset5 from "../../assets/img/project/asset-management/Asset5.png";

// Attendance Management System (Web)
import Atten1 from "../../assets/img/project/attendance-management/Atten1.png";
import Atten2 from "../../assets/img/project/attendance-management/Atten2.png";
import Atten3 from "../../assets/img/project/attendance-management/Atten3.png";
import Atten4 from "../../assets/img/project/attendance-management/Atten4.png";
import Atten5 from "../../assets/img/project/attendance-management/Atten5.png";

// eStock Mobile App
import estockMobile1 from "../../assets/img/project/estock-mobile/estockMobile1.png";
import estockMobile2 from "../../assets/img/project/estock-mobile/estockMobile2.png";
import estockMobile3 from "../../assets/img/project/estock-mobile/estockMobile3.png";
import estockMobile4 from "../../assets/img/project/estock-mobile/estockMobile4.png";
import estockMobile5 from "../../assets/img/project/estock-mobile/estockMobile5.png";
import estockMobile6 from "../../assets/img/project/estock-mobile/estockMobile6.png";
import estockMobile7 from "../../assets/img/project/estock-mobile/estockMobile7.png";
import estockMobile8 from "../../assets/img/project/estock-mobile/estockMobile8.png";
import estockMobile9 from "../../assets/img/project/estock-mobile/estockMobile9.png";

// Attendance Admin Mobile App
import AttenAdmin1 from "../../assets/img/project/attendance-admin/AttenAdmin1.png";
import AttenAdmin2 from "../../assets/img/project/attendance-admin/AttenAdmin2.png";
import AttenAdmin3 from "../../assets/img/project/attendance-admin/AttenAdmin3.png";
import AttenAdmin4 from "../../assets/img/project/attendance-admin/AttenAdmin4.png";
import AttenAdmin5 from "../../assets/img/project/attendance-admin/AttenAdmin5.png";
import AttenAdmin6 from "../../assets/img/project/attendance-admin/AttenAdmin6.png";
import AttenAdmin7 from "../../assets/img/project/attendance-admin/AttenAdmin7.png";
import AttenAdmin8 from "../../assets/img/project/attendance-admin/AttenAdmin8.png";

// Attendance Employee App
import AttenEmp1 from "../../assets/img/project/attendance-employee/AttenEmp1.png";
import AttenEmp2 from "../../assets/img/project/attendance-employee/AttenEmp2.png";
import AttenEmp3 from "../../assets/img/project/attendance-employee/AttenEmp3.png";
import AttenEmp4 from "../../assets/img/project/attendance-employee/AttenEmp4.png";
import AttenEmp5 from "../../assets/img/project/attendance-employee/AttenEmp5.png";
import AttenEmp6 from "../../assets/img/project/attendance-employee/AttenEmp6.png";
import AttenEmp7 from "../../assets/img/project/attendance-employee/AttenEmp7.png";

// Quarter Management System (Indian Army)
import QM1 from "../../assets/img/project/quarterManagement/QM1.png";
import QM2 from "../../assets/img/project/quarterManagement/QM2.png";
import QM3 from "../../assets/img/project/quarterManagement/QM3.png";
import QM4 from "../../assets/img/project/quarterManagement/QM4.png";
import QM5 from "../../assets/img/project/quarterManagement/QM5.png";
import QM7 from "../../assets/img/project/quarterManagement/QM7.png";
import QM8 from "../../assets/img/project/quarterManagement/QM8.png";
import QM9 from "../../assets/img/project/quarterManagement/QM9.png";
import QM10 from "../../assets/img/project/quarterManagement/QM10.png";

// Project data
export const projectsData = [
  {
    id: "erestaurant",
    title: "eRestaurant POS System",
    category: "Web Applications",
    type: "Business Systems",
    platform: "Web",
    mainImage: Res1,
    client: "Food Service Business",
    timeline: "8 Weeks",
    technology: "React, Node.js, Express, SQL",
    overview: {
      challenge:
        "Food service businesses including restaurants, fast food shops, ice cream parlors, and cafes struggle with order management, inventory tracking, and sales reporting using traditional manual systems. They need comprehensive point-of-sale systems to streamline operations and improve customer service.",
      solution:
        "I developed a complete restaurant POS system using React and Node.js that handles order management, inventory tracking, table management, kitchen display system, detailed reporting, and real-time sales analytics - revolutionizing food service operations for any type of establishment.",
    },
    problemStatement:
      "Food service businesses face significant challenges with order accuracy, inventory management, and long customer wait times. Staff spend excessive time on manual calculations and inventory checks, leading to errors and inefficient service across all types of food establishments.",
    developmentProcess:
      "The development began with thorough analysis of food service workflow and staff requirements. Built using React for responsive frontend and Node.js with Express and SQL database for robust backend operations. The system includes integrated payment processing, kitchen display systems, detailed reporting, and real-time inventory updates.",
    results: [
      "Reduced order processing time by 60%",
      "Eliminated manual inventory tracking errors",
      "Integrated kitchen display system for better order management",
      "Real-time sales and inventory analytics dashboard with detailed reports",
      "Automated billing and payment processing",
      "Staff training and performance tracking modules",
    ],
    roi: "Food service businesses estimate a 40% increase in operational efficiency and 25% reduction in food waste through better inventory management.",
    images: [Res1, Res3, Res2, Res4, Res5],
  },
  {
    id: "estock",
    title: "eStock Inventory Management",
    category: "Web Applications",
    type: "Business Systems",
    platform: "Web",
    mainImage: Stock1,
    client: "Retail Business",
    timeline: "6 Weeks",
    technology: "React, Node.js, Express, SQL",
    overview: {
      challenge:
        "Growing retail businesses lose revenue due to stockouts and overstocking issues. Manual inventory tracking systems can't keep up with expanding product catalogs and multiple warehouse locations, affecting businesses of all sizes.",
      solution:
        "I created a comprehensive inventory management system that automates stock tracking, provides real-time inventory levels, generates purchase orders, offers predictive analytics for demand forecasting, and includes detailed reporting for complete business insights.",
    },
    problemStatement:
      "Retail businesses face constant inventory discrepancies, leading to lost sales from stockouts and tied-up capital in overstock. Manual tracking across multiple locations is time-consuming and error-prone for any retail operation.",
    developmentProcess:
      "Development focused on creating a scalable multi-location inventory system. Used React for the dashboard interface and Node.js with Express and SQL for handling complex inventory relationships and transaction history. Integrated barcode scanning, automated reorder points, and comprehensive reporting.",
    results: [
      "Reduced stockouts by 75% through automated reorder alerts",
      "Cut inventory carrying costs by 30%",
      "Multi-location inventory synchronization",
      "Barcode scanning for instant updates",
      "Automated purchase order generation",
      "Advanced analytics and detailed demand forecasting reports",
    ],
    roi: "Businesses see a 35% improvement in inventory turnover and reduced manual labor costs by 50% within the first quarter.",
    images: [Stock1, Stock2, Stock5, Stock4, Stock3],
  },
  {
    id: "asset-management",
    title: "Asset Management System",
    category: "Web Applications",
    type: "Business Systems",
    platform: "Web",
    mainImage: Asset1,
    client: "Corporate Office",
    timeline: "12 Weeks",
    technology: "React, Node.js, Express, SQL",
    overview: {
      challenge:
        "Growing companies struggle to track and manage their increasing inventory of office assets including laptops, furniture, stationery, and equipment. They lack visibility into asset allocation, maintenance schedules, and have no systematic way to handle asset transfers between employees.",
      solution:
        "I created a comprehensive asset management system that tracks all company assets from procurement to disposal, manages employee assignments, handles transfers, maintenance scheduling, provides detailed reporting and analytics for complete asset lifecycle management.",
    },
    problemStatement:
      "Companies have no centralized system to track where assets are located, who is responsible for them, or their current condition. This leads to asset losses, duplicate purchases, and inefficient resource allocation across organizations of all sizes.",
    developmentProcess:
      "Development involved creating a robust asset tracking database with barcode/QR code integration, employee management, automated workflows, and comprehensive reporting systems. Built using React for the admin dashboard and Node.js with Express and SQL for complex relational data management.",
    results: [
      "Complete asset lifecycle tracking from purchase to disposal",
      "Automated asset assignment and transfer workflows",
      "Maintenance scheduling and alerts system",
      "Barcode/QR code scanning for instant asset identification",
      "Comprehensive reporting and analytics dashboard with detailed insights",
      "Integration with HR systems for employee asset tracking",
    ],
    roi: "Companies reduce asset-related operational costs by 40% and eliminate duplicate asset purchases, saving $50,000+ annually through detailed tracking and reporting.",
    images: [Asset1, Asset2, Asset4, Asset3, Asset5],
  },
  {
    id: "stocktally",
    title: "StockTally Mobile App",
    category: "Mobile Apps",
    type: "Business Systems",
    platform: "Mobile",
    mainImage: stocktally1,
    client: "Jewelry Business",
    timeline: "5 Weeks",
    technology: "React Native, Node.js, Express, SQL",
    overview: {
      challenge:
        "Jewelry store owners and jewellers need an efficient way to conduct daily stock tallies and reconcile inventory discrepancies. The manual counting process is time-consuming and prone to errors, especially for high-value items that all jewelry businesses handle.",
      solution:
        "I developed a mobile app using React Native that allows jewelry store staff to quickly scan, count, and verify inventory items, automatically detecting discrepancies, generating detailed reports for management review, and providing comprehensive analytics for better inventory control.",
    },
    problemStatement:
      "Daily stock verification takes 3-4 hours per store for most jewellers, with frequent counting errors leading to inventory discrepancies. High-value jewelry items require extra verification, making the process complex for any jewelry business.",
    developmentProcess:
      "The mobile app was designed for ease of use on tablets and smartphones. Built with React Native for cross-platform compatibility, featuring barcode scanning, photo capture for item verification, offline capability for areas with poor connectivity, and detailed reporting systems.",
    results: [
      "Reduced daily stock counting time from 4 hours to 45 minutes",
      "Eliminated manual counting errors through barcode scanning",
      "Real-time discrepancy alerts and photo documentation",
      "Offline functionality for uninterrupted counting",
      "Detailed automated report generation for management",
      "Integration with existing POS systems",
    ],
    roi: "Jewelry stores save 20+ hours per week on inventory management and reduce shrinkage by 15% through better tracking and detailed reporting.",
    images: [stocktally1, stocktally2, stocktally3, stocktally4, stocktally5, stocktally6, stocktally7, stocktally8],
  },
  {
    id: "crm-system",
    title: "Customer Relationship Manager",
    category: "Web Applications",
    type: "Business Systems",
    platform: "Web",
    mainImage: CRM1,
    client: "Sales Organization",
    timeline: "10 Weeks",
    technology: "React, Node.js, Express, SQL",
    overview: {
      challenge:
        "Sales organizations struggle to manage customer relationships, track leads, monitor sales performance, handle complaints, and manage tasks across their teams. Customer data scattered across different platforms makes follow-ups and reporting difficult for any business with sales operations.",
      solution:
        "I built a comprehensive CRM system that centralizes customer data, automates lead tracking, provides complete complaint management, task management, sales pipeline management, and offers detailed reporting with real-time analytics for better decision making.",
    },
    problemStatement:
      "Sales teams lose potential customers due to poor lead management, lack of systematic follow-up processes, inefficient complaint handling, and poor task management. Customer interaction history is not properly documented, leading to inconsistent service quality.",
    developmentProcess:
      "The CRM development involved creating a unified customer database with interaction tracking, automated workflow triggers, customizable sales pipelines, comprehensive complaint management system, task management with assignments, and detailed reporting modules. Built with React for dynamic user interface and Node.js with Express and SQL backend.",
    results: [
      "Increased lead conversion rate by 45%",
      "Centralized customer communication history with complaint tracking",
      "Automated follow-up reminders and comprehensive task management",
      "Customizable sales pipeline management",
      "Real-time team performance dashboards with detailed reports",
      "Complete complaint management and resolution tracking",
    ],
    roi: "Organizations report a 50% increase in sales productivity and 30% improvement in customer retention rates with better complaint resolution.",
    images: [CRM1, CRM2, CRM3, CRM1, CRM1],
  },
  {
    id: "attendance-management",
    title: "Attendance Management System",
    category: "Web Applications",
    type: "Business Systems",
    platform: "Web",
    mainImage: Atten1,
    client: "HR Department",
    timeline: "14 Weeks",
    technology: "React, Node.js, Express, SQL",
    overview: {
      challenge:
        "Companies with biometric attendance systems struggle to process raw attendance data effectively. HR departments face challenges in calculating accurate work hours, managing late arrivals, tracking absences, processing holidays, and generating precise salary calculations based on actual working hours.",
      solution:
        "I developed a comprehensive attendance management system that processes raw biometric data, calculates precise work hours, manages employee schedules, handles leave management, tracks late arrivals and absences, and automatically calculates monthly salaries based on actual hours worked with holiday and overtime considerations.",
    },
    problemStatement:
      "Organizations waste countless hours manually processing biometric attendance data, calculating work hours, and determining salary adjustments. Manual processing leads to payroll errors, disputes over attendance records, and inefficient HR operations across companies of all sizes.",
    developmentProcess:
      "The system development focused on creating automated data processing pipelines for biometric machine integration, complex attendance calculations, leave management workflows, and comprehensive HR analytics. Built using React for intuitive dashboards and Node.js with Express and SQL for handling complex attendance algorithms and payroll calculations.",
    results: [
      "Automated processing of raw biometric attendance data",
      "Precise work hour calculations with overtime and break deductions",
      "Comprehensive leave management system with approval workflows",
      "Late arrival and absence tracking with automated alerts",
      "Holiday management and calendar integration",
      "Automated monthly salary calculations based on actual hours worked",
      "Detailed employee attendance reports and analytics",
      "Full-scale HR management with employee tracking capabilities",
    ],
    roi: "Companies reduce HR processing time by 80% and eliminate payroll discrepancies, saving $75,000+ annually while improving employee satisfaction through accurate attendance tracking.",
    images: [Atten1, Atten2, Atten3, Atten4, Atten5],
  },
  {
    id: "estock-mobile",
    title: "eStock Mobile App",
    category: "Mobile Apps",
    type: "Business Systems",
    platform: "Mobile",
    mainImage: estockMobile1,
    client: "Retail & Distribution Business",
    timeline: "10 Weeks",
    technology: "React Native, Node.js, Express, SQL",
    overview: {
      challenge:
        "Retail and distribution businesses need comprehensive mobile solutions for their field sales teams and administrators. Salesmen require real-time inventory access, location-based features for route optimization, and the ability to process dispatches and issue receipts on the go. Admins need complete visibility and control over all field operations.",
      solution:
        "I developed a powerful mobile application using React Native that provides full capabilities for both salesmen and admins. The app includes geofencing and GPS location tracking for salesmen, complete dispatch management, instant receipt generation, real-time inventory sync, and comprehensive admin controls for monitoring all field activities.",
    },
    problemStatement:
      "Field sales teams struggle with outdated paper-based systems for order taking, dispatch management, and receipt generation. Admins have no real-time visibility into salesman locations or activities. Manual processes lead to errors, delayed order processing, and lack of accountability in field operations.",
    developmentProcess:
      "The development focused on creating a robust cross-platform mobile solution with role-based access for salesmen and admins. Built with React Native for seamless Android and iOS compatibility, integrated GPS and geofencing APIs for location tracking, implemented offline-first architecture for areas with poor connectivity, and designed comprehensive dispatch and receipt management modules.",
    results: [
      "Complete salesman management with GPS location tracking",
      "Geofencing capabilities for territory management and route optimization",
      "Real-time dispatch management and order processing",
      "Instant digital receipt generation and sharing",
      "Full admin dashboard with live salesman tracking",
      "Offline functionality for uninterrupted field operations",
      "Real-time inventory sync across all locations",
      "Comprehensive reporting and analytics for field activities",
      "Push notifications for order updates and alerts",
    ],
    roi: "Businesses achieve 50% improvement in field sales efficiency, 40% reduction in order processing time, and complete visibility into field operations leading to better resource allocation and increased sales.",
    images: [estockMobile1, estockMobile2, estockMobile3, estockMobile4, estockMobile5, estockMobile6, estockMobile7, estockMobile8, estockMobile9],
  },
  {
    id: "attendance-admin",
    title: "Attendance Admin Mobile App",
    category: "Mobile Apps",
    type: "Business Systems",
    platform: "Mobile",
    mainImage: AttenAdmin1,
    client: "Multi-Branch Organizations",
    timeline: "8 Weeks",
    technology: "React Native, Node.js, Express, SQL",
    overview: {
      challenge:
        "Company owners, managers, and administrators managing multiple branches and locations need instant access to complete employee attendance data from anywhere. They need to monitor attendance across all locations, approve leave requests promptly, track employee work hours, and make informed decisions without being tied to a desktop system.",
      solution:
        "I developed a powerful admin mobile app as part of the complete Attendance Management package. This app gives company owners, managers, and HR admins complete control over attendance operations across all branches and locations. From viewing real-time attendance of any employee at any branch to approving leaves instantly, generating year-round reports, and managing the entire workforce - everything is accessible from their mobile devices.",
    },
    problemStatement:
      "Organizations with multiple branches struggle to maintain oversight of employee attendance across locations. Owners and managers cannot access attendance data while traveling or away from office. Leave approvals get delayed, attendance discrepancies go unnoticed, and there's no unified view of workforce attendance across the entire organization. Decision-makers need complete visibility into their workforce from anywhere, anytime.",
    developmentProcess:
      "This app was built as a companion to the web-based Attendance Management System, designed specifically for company leadership and administrators. Built with React Native for seamless cross-platform use, the app connects to the central attendance database providing real-time data synchronization. Features include multi-branch data access with branch-wise filtering, comprehensive employee profiles with complete attendance history, leave management with instant approval/rejection capabilities, and detailed analytics spanning daily, monthly, and yearly reports.",
    results: [
      "Complete attendance visibility across all branches and locations",
      "Real-time employee attendance status - who's present, absent, or on leave",
      "Full employee attendance history and work hour records for any time period",
      "Instant leave request approval and rejection with notification to employees",
      "Branch-wise and department-wise attendance filtering and reports",
      "Year-round attendance analytics with daily, monthly, and annual summaries",
      "Late arrival and early departure tracking across the organization",
      "Employee-wise detailed reports including overtime, absences, and leave balance",
      "Push notifications for leave requests, attendance alerts, and anomalies",
      "Secure role-based access for owners, managers, and HR administrators",
    ],
    roi: "Company owners and managers save 10+ hours weekly by accessing attendance data on-the-go. Leave approval times reduced from days to minutes. Complete workforce visibility leads to better resource planning and 40% improvement in attendance compliance across branches.",
    images: [AttenAdmin1, AttenAdmin2, AttenAdmin3, AttenAdmin4, AttenAdmin5, AttenAdmin6, AttenAdmin7, AttenAdmin8],
  },
  {
    id: "attendance-employee",
    title: "Attendance Employee App",
    category: "Mobile Apps",
    type: "Business Systems",
    platform: "Mobile",
    mainImage: AttenEmp1,
    client: "Workforce & Employees",
    timeline: "7 Weeks",
    technology: "React Native, Node.js, Express, SQL, GPS/Geofencing APIs",
    overview: {
      challenge:
        "Employees need a simple yet secure way to mark their attendance without manual registers or biometric machines at every location. They also need access to their attendance records, salary information, and the ability to apply for leaves directly from their phones. Organizations need to ensure attendance is marked only from authorized locations.",
      solution:
        "I developed a comprehensive employee attendance app with built-in geofencing and GPS location tracking. Employees can only mark attendance when they are within the designated office premises or work location. The app provides complete access to attendance history, salary details, leave balances, and a streamlined leave application process - all secured with location verification.",
    },
    problemStatement:
      "Traditional attendance systems require employees to be physically present at biometric machines or sign registers, causing queues and wasted time. Employees have no visibility into their attendance records or salary calculations until month-end. Leave applications involve paperwork and delays. Remote and field employees have no reliable way to mark attendance from different work locations.",
    developmentProcess:
      "The app was built with React Native for cross-platform compatibility, integrating advanced GPS and geofencing capabilities. The geofencing system creates virtual boundaries around office locations - attendance can only be marked when the employee's device is within these boundaries. Implemented secure authentication, real-time location verification, and seamless integration with the central Attendance Management System for instant data sync.",
    results: [
      "One-tap attendance marking with geofencing verification",
      "GPS location tracking to ensure attendance from authorized locations only",
      "Complete attendance history with daily, weekly, and monthly views",
      "Real-time salary information and detailed salary breakdowns",
      "Easy leave application with leave balance visibility",
      "View approved, pending, and rejected leave requests",
      "Notifications for attendance confirmations and leave updates",
      "Support for multiple office locations with location-based attendance",
      "Offline attendance marking with auto-sync when online",
      "Secure login with employee credentials",
    ],
    roi: "Organizations eliminate buddy punching and fake attendance completely through geofencing. Employees save 15+ minutes daily avoiding biometric queues. 95% reduction in leave application processing time with digital workflows.",
    images: [AttenEmp1, AttenEmp2, AttenEmp3, AttenEmp4, AttenEmp5, AttenEmp6, AttenEmp7],
  },
  {
    id: "quarter-management",
    title: "Quarter Management System",
    category: "Web Applications",
    type: "Government Systems",
    platform: "Web",
    mainImage: QM1,
    client: "Indian Army - Delhi Headquarters",
    timeline: "16 Weeks",
    technology: "React, Node.js, Express, SQL (Offline-First Architecture)",
    disclaimer: "**IMPORTANT: This application works completely OFFLINE. The version shown here is a DEMO/TESTING version with DUMMY DATA and represents only a part of the full application. This is not connected to any real Army systems or data.**",
    overview: {
      challenge:
        "The Indian Army Delhi Headquarters faced significant challenges in managing quarters allocation for army personnel. The traditional paper-based system led to lost applications, misplaced records, and army personnel waiting for years without receiving their entitled quarters. There was no efficient way to track quarter availability, maintenance status, or application processing.",
      solution:
        "I developed a comprehensive Quarter Management System that digitizes the entire quarters allocation process. **The system works completely OFFLINE** to ensure functionality in secure environments without internet connectivity. It tracks all quarters (vacant, occupied, under maintenance), manages applications, handles allotments, and provides timely accommodation to army personnel - eliminating the critical problems of the paper-based system.",
    },
    problemStatement:
      "The paper-based quarter management system at Army Headquarters suffered from critical issues: lost applications, misplaced files, no tracking of application status, unclear quarter availability, and army personnel waiting years for quarters they were entitled to. The lack of digitalization meant no accountability, delayed allotments, and frustrated personnel who had no visibility into the process.",
    developmentProcess:
      "The development focused on creating a robust **offline-first web application** that functions without internet connectivity - a critical requirement for secure military environments. Built using React for the frontend with local database synchronization, Node.js with Express for backend services, and SQL database optimized for offline operations. The system includes comprehensive quarter tracking, application management, allotment workflows, and detailed reporting - all functioning completely offline.",
    results: [
      "**Complete digitalization** replacing the paper-based system entirely",
      "**Offline functionality** - system works without internet connectivity",
      "Comprehensive quarter tracking - vacant, occupied, and under maintenance status",
      "Streamlined application submission and tracking process",
      "Automated allotment workflow with priority-based processing",
      "Eliminated lost applications and misplaced records",
      "Real-time visibility into application status for personnel",
      "Detailed reporting and analytics for administration",
      "Reduced waiting time for quarter allotments significantly",
      "Complete audit trail of all transactions and decisions",
    ],
    roi: "The system eliminates paper-based inefficiencies, reduces allotment processing time by 70%, and ensures no application is ever lost. Army personnel now have complete visibility into their application status, leading to improved satisfaction and trust in the system.",
    images: [QM1, QM2, QM3, QM4, QM5, QM7, QM8, QM9, QM10],
  },
];

// Helper function to get projects by category
export const getProjectsByCategory = (category) => {
  if (category === "All Projects") return projectsData;
  return projectsData.filter((project) => project.category === category);
};

// Make data available globally for ProjectDetails
if (typeof window !== "undefined") {
  window.projectsData = projectsData;
}
